import { useState } from 'react';
import { testimonials } from '@/mocks/siteData';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const handlePrev = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const t = testimonials[current];

  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="relative rounded-3xl bg-foreground-950 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative min-h-64 lg:min-h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20yet%20relaxed%20workspace%20scene%20with%20person%20working%20on%20laptop%20at%20wooden%20desk%2C%20warm%20natural%20lighting%20streaming%20through%20window%2C%20fashion%20moodboard%20visible%20on%20wall%2C%20cream%20and%20warm%20beige%20interior%2C%20genuine%20candid%20moment%2C%20editorial%20lifestyle%20photography%2C%20aspirational%20modern%20office%20aesthetic&width=900&height=1200&seq=testim-v2-d5f&orientation=portrait"
                alt="Oopbuyspreadsheet user workspace"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center p-8 md:p-12 lg:p-16 relative">
              <div className="text-8xl md:text-9xl font-heading font-bold text-accent-200/25 leading-none select-none absolute top-6 left-6">
                &ldquo;
              </div>

              <div className="relative z-10">
                <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
                  {t.text}
                </p>

                <div className="mb-8">
                  <p className="text-base font-semibold text-white">{t.name}</p>
                  <p className="text-sm text-white/50">{t.role}</p>
                </div>

                <div className="flex items-center gap-6">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={handlePrev}
                      className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white/10 transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-left-line text-sm"></i>
                    </button>
                    <button
                      onClick={handleNext}
                      className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white/10 transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-right-line text-sm"></i>
                    </button>
                  </div>

                  <div className="flex items-center gap-1.5">
                    {testimonials.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setCurrent(idx)}
                        className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                          idx === current ? 'bg-accent-400 w-6' : 'bg-white/20'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}